export const VWO_MAIN_ACCOUNT_ID = '638475';
export const VWO_USER_ID_STORAGE_KEY = '__vwoUserId';
export const VWO_SETTINGS_FILE_STORAGE_KEY = '__vwoSettingsFile';
export const VWO_FEATURE_FLAG_VALUES_RECEIVED = '__vwoFeatureFlagsReceived';
